import { useState, useCallback } from "react";

export function useDelayedAction(defaultDelay = 1000) {
    const [isLoading, setIsLoading] = useState(false);

    const trigger = useCallback((callback, delay = defaultDelay) => {
        setIsLoading(true);
        const timer = setTimeout(() => {
        callback?.();
        setIsLoading(false);
        }, delay);

        return () => clearTimeout(timer); // cleanup if needed
    }, [defaultDelay]);

    return { isLoading, trigger };
}